import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { ApiDirectory } from '@core/api/api-directory';
import { RequestResponse } from '@core/services/request/model/request.model';
import { RequestService } from '@core/services/request/request.service';
import { ConsumptionRequestApi } from '../../model/consumption/consumption-request-api.model';
import { LoadingIds } from '@shared/constants/loading';

@Injectable({ providedIn: 'root' })
export class ApiConsumptionRequestService {
  constructor(private _requestService: RequestService) {}

  public fetchConsumptionRequest(): Observable<RequestResponse<Array<ConsumptionRequestApi>>> {
    return this._requestService.get(ApiDirectory.Consumo.ListadoPeticiones({}), {
      loading: LoadingIds.FETCH_CONSUMPTION_REQUESTS,
    });
  }

  public downloadConsumptionRequestDocument(idPeticio: number) {
    return this._requestService.downloadWithProgress(ApiDirectory.Consumo.DescargarFicheroPeticion({ idPeticio }));
  }
}
